import {collection, component, dateField, EntityData, field, identifier} from "@fedeltapointofsale/data-client";

export class RecUserData extends EntityData<RecUserData> {
    @field name: string;
    @field firstName: string;
    @field lastName: string;
}

export class BalanceData extends EntityData<BalanceData> {
    @identifier id: number;
    @field tender: string;
    @field accountingType: number;
    @field balanceTotal: number;
    @field userTotal: number;
    @field systemTotal: number;
}

export class TillData extends EntityData<TillData> {
    @identifier tillId: string;
    @dateField startTime: Date;
    @dateField finishTime: Date;
    @dateField firstBalanceDate: Date;
    @component firstRecUser: RecUserData;
    @dateField balanceDate: Date;
    @field balanceTotal: number;
    @field cashout: number;
    @component recUser: RecUserData;
    @field terminalName: string;
    @field note100: number;
    @field note50: number;
    @field note20: number;
    @field note10: number;
    @field note5: number;
    @field coin200: number;
    @field coin50: number;
    @field coin100: number;
    @field coin20: number;
    @field coin10: number;
    @field coin5: number;
    @field coin2: number;
    @field coin1: number;
    @collection(BalanceData) balancedTenders: BalanceData[];
}

export class FloatData extends EntityData<FloatData> {
    @identifier floatId: string;
    @field floatIn: number;
    @field floatOut: number;
    @component inRecUser: RecUserData;
    @component outRecUser: RecUserData;
    @component verifiedByRecUser: RecUserData;
    @field balanceStatus: number;
    @component till: TillData;
}
